import {useState, useEffect} from 'react';
import {loadConnectAndInitialize} from '@stripe/connect-js';
import {
  fetchRequest,
  securedFetchRequest,
} from '@bidmii/common/lib/util/FetchRequest';
import {API_URL} from '../constants';
import {useSetRecoilState} from 'recoil';
import {loadingState} from '../recoil/bidmiiCustomLoader/bidmiiCustomLoaderAtom';

export const useStripeConnect = (connectedAccountId) => {
  const setLoading = useSetRecoilState(loadingState);
  const [stripeConnectInstance, setStripeConnectInstance] = useState();

  useEffect(() => {
    if (connectedAccountId) {
      setLoading(true);

      const requestFunction =
        process.env.REACT_APP_FORCE_WEB_VIEW === '1' ||
        window.ReactNativeWebView
          ? fetchRequest
          : securedFetchRequest;
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({account: connectedAccountId}),
      };
      if (
        process.env.REACT_APP_FORCE_WEB_VIEW === '1' ||
        window.ReactNativeWebView
      ) {
        options.headers['Firebase-Authorization'] = sessionStorage.getItem(
          'Firebase-Authorization',
        );
      }

      const fetchClientSecret = async () => {
        const response = await requestFunction(
          `${API_URL}/user-account-session`,
          options,
        );
        setLoading(false);

        if (!response.ok) {
          // Handle errors on the client side here
          const {error} = await response.json();
          throw ('An error occurred: ', error);
        } else {
          const {client_secret: clientSecret} = await response.json();
          return clientSecret;
        }
      };

      console.log(
        `PUBLISHABLE KEY: ${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}`,
      );

      setStripeConnectInstance(
        loadConnectAndInitialize({
          publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
          fetchClientSecret,
          appearance: {
            overlays: 'dialog',
            variables: {
              colorPrimary: '#635BFF',
            },
          },
        }),
      );
    }
  }, [connectedAccountId, setLoading]);

  return stripeConnectInstance;
};

export default useStripeConnect;
